<template>
<div class="chapter">
<div class="inner_page">
<p class="imgcenter"><img alt="images" src="images/img12.jpg"/></p>
<p class="caption"><em class="italic">Old Town Gaol, St John Street, c.1890.</em> <span class="caption1">Nottingham City Library</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 05c_FOULDEEDSNOTTINGHAM_CHAPTER01.vue?94e7c3e8